import React, { forwardRef } from 'react';
import { icons, LucideIcon } from 'lucide-react';
import { cn } from '@/lib/utils';

interface DynamicIconProps {
  name: string;
  className?: string;
  size?: number;
}

const DynamicIcon = forwardRef<SVGSVGElement, DynamicIconProps>(
  ({ name, className, size }, ref) => {
    const IconComponent = icons[name as keyof typeof icons] as LucideIcon | undefined;

    if (!IconComponent) {
      // Fallback to a default icon
      const FallbackIcon = icons['Circle'] as LucideIcon;
      return <FallbackIcon ref={ref} className={cn('h-4 w-4', className)} size={size} />;
    }

    return <IconComponent ref={ref} className={cn('h-4 w-4', className)} size={size} />;
  }
);

DynamicIcon.displayName = 'DynamicIcon';

export default DynamicIcon;
